import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import Transition from '@ember/routing/-private/transition';
import Model from '@ember-data/model';
import MessageSettingsService from 'cio/services/message-settings';
import IndexController from 'cio/pods/workspace-settings/index/controller';
import EnvironmentModel from 'cio/models/environment';
import AccountService from 'cio/services/account';

export default class IndexRoute extends Route {
  @service messageSettings!: MessageSettingsService;
  @service account!: AccountService;

  async afterModel(model: EnvironmentModel, transition: Transition) {
    await this.messageSettings.loadMessagingLimit.perform();

    return super.afterModel(model, transition);
  }

  setupController(controller: IndexController, model: Model, transition: Transition) {
    super.setupController(controller, model, transition);

    if (this.account.isJourneysActivated) {
      this.messageSettings.loadURLParamsCredential.perform();
    }
  }
}
